import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'child-cell',
    template: `<span><button style="margin-top:0px;padding: 1px 3px !important;"  color="link" size="sm" class="waves-light edit-button btn btn-sm" (click)="delete()" >
    <i class="icon-delete"></i>
</button>
</span>`,
    styles: [
    ]
})
export class DeleteOperationsRenderer implements ICellRendererAngularComp {
    public params: any;

    agInit(params: any): void {
        this.params = params;
    }

    public delete() {
        this.params.context.componentParent.deleteRow(this.params)
    }

    refresh(): boolean {
        return false;
    }
}